import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  useMediaQuery,
} from "@mui/material";
import ClientReportView from "./ClientReport";
import CandidateReportView from "./CandidateReport";
import StaffReportView from "./StaffReport";
import JobReportView from "./JobReport";
import SystemReportView from "./SystemReport";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import CancelIcon from "@mui/icons-material/Cancel";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import WebAssetOffIcon from "@mui/icons-material/WebAssetOff";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import GroupIcon from "@mui/icons-material/Group";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import WorkIcon from "@mui/icons-material/Work";
import PostAddIcon from "@mui/icons-material/PostAdd";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import DomainAddIcon from "@mui/icons-material/DomainAdd";

const tabLabels = [
  "Clients",
  "Candidates",
  "Jobs",
  "Staffs",
  // "System",
];

const Reports = () => {
  const [year, setYear] = useState("2025");
  const [year3, setYear3] = useState("2025");

  const [yearOptions, setYearOptions] = useState([]);

  // Client        ___________________________________________________________________________________________________________________________________________________________________________________
  const [clientStatData, setclientStatData] = useState([
    { title: "Total Clients", value: 0 },
    { title: "Active Clients", value: 0 },
    { title: "Inactive Clients", value: 0 },
  ]);
  const [mostCandidateDeployed, setMCD] = useState();
  const [topClients, setTopClients] = useState([]);

  // Candidate     ___________________________________________________________________________________________________________________________________________________________________________________
  const [candidateStatData, setCandidateStatData] = useState([]);
  const [candidateProcessData, setCandidateProcessData] = useState([]);

  const [countriesInProgress, setCountriesInProgress] = useState([]);
  const [depoyedByCountry, setDepoyedByCountry] = useState([]);
  const [professionStats, setProfessionStats] = useState([]);

  const [JobList, setJobList] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  const [processList, setProcessList] = useState([]);
  const [processName, setProcessName] = useState(null);

  const [staffList, setStaffList] = useState([]);
  const [staffName, setStaffName] = useState("");
  const [staffName2, setStaffName2] = useState("");
  const [staffName3, setStaffName3] = useState("");
  const [staffName4, setStaffName4] = useState("");
  const [staffName5, setStaffName5] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [interviewStats, setInterviewStats] = useState([]);

  // Job           ____________________________________________________________________________________________________________________________________________________________________________________
  const [jobStatData, setJobStatData] = useState([]);
  const [jobPostStats, setJobPostStats] = useState([]);
  const [jobProfStats, setJobProfStats] = useState([]);
  const [jobClientStats, setJobClientStats] = useState([]);
  const [NewClientData, setNewClientData] = useState([]);
  const [jobApplicationData, setJobApplicationData] = useState([]);
  const [deployedJobStats, setDeployedJobStats] = useState([]);

  // Staff         ____________________________________________________________________________________________________________________________________________________________________________________
  const [staffProcessStats, setStaffProcessStats] = useState([]);
  const [recruitmentStage, setRecruitmentStage] = useState("");
  const [RecruitmentStageslist, setRecruitmentStageslist] = useState([]);
  const [staffInterviewScheduledList, setStaffInterviewScheduledList] = useState([]);
  const [staffCancelRate, setStaffCancelRate] = useState({});
  const [staffOfferStats, setStaffOfferStats] = useState({});
  const [candidateByStaff, setCandidateByStaff] = useState();

  const [statusList, setStatusList] = useState([]);
  const [interviewStatus, setInterviewStatus] = useState("");

  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Client API    ____________________________________________________________________________________________________________________________________________________________________________________

  const getClientData = async () => {
    await axiosAPI
      ?.get(`/reports/Clientcount`)
      .then((res) => {
        const apiData = res?.data?.data;

        if (apiData) {
          const colors = [
            "#D6ECFF", // Light Blue
            "#E4F9E3", // Light Green
            "#FFEBCB", // Light Orange
            "#DEE5FF", // Soft Indigo
            "#FFD6D6", // Light Rose
            "#D4F1FF", // Ice Blue
            "#E3EEFF", // Pale Sky
            "#F0DEFF", // Light Lavender
            "#E9F8E5", // Minty Green
            "#FFDFF0", // Baby Pink
          ];

          const updatedclientStatData = [
            {
              title: "Total Clients",
              value: apiData.totalClients,
              Icon: <PeopleIcon />,
            },
            {
              title: "Active Clients",
              value: apiData.activeClients,
              Icon: <PersonIcon />,
            },
            {
              title: "Inactive Clients",
              value: apiData.inactiveClients,
              Icon: <PersonOffIcon />,
            },
          ].map((stat, index) => ({
            ...stat,
            color: colors[index % colors.length],
          }));

          setclientStatData(updatedclientStatData);
        }
      })
      .catch((err) => {});

    await axiosAPI
      ?.get(`/reports/deployed-client-stats`)
      .then((res) => {
        const apiData = res?.data?.data;

        setMCD(apiData);
      })
      .catch((err) => {});
  };

  const getClientJobPosted = async () => {
    await axiosAPI
      ?.post(`/reports/new-client/quarter`, {
        year: year,
      })
      .then((res) => {
        setNewClientData(res?.data?.data);
      })
      .catch((err) => {});
  };

  const getTopClients = async () => {
    await axiosAPI
      ?.get(`/reports/Top-clients`)
      .then((res) => {
        setTopClients(res?.data?.data);
      })

      .catch((err) => {});
  };

  const getStaff = async () => {
    try {
      const res = await axiosAPI.get(`/Employee/reportingstaff`);
      setStaffList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // Candidate API  ___________________________________________________________________________________________________________________________________________________________________________________

  const getCandidateStats = async () => {
    try {
      const [
        summaryRes,
        delayRes,
        selectionRes,
        docSubRateRes,
        offerAcceptanceRate,
        cancellationRate,
      ] = await Promise.all([
        axiosAPI.get(`/reports/Candidate-summary`),
        axiosAPI.get(`/reports/candidate-deploymentdelay`),
        axiosAPI.get(`/reports/candidate-selection`),
        axiosAPI.get(`/reports/Document-submission-rate`),
        axiosAPI.get(`/reports/offer-acceptance-rate`),
        axiosAPI.get(`/reports/cancellation-rate`),
      ]);

      const delayData = delayRes?.data?.data;
      const summaryData = summaryRes?.data?.data;
      const selectionData = selectionRes?.data?.data;
      const docSubRateData = docSubRateRes?.data?.data;
      const offerAcceptanceData = offerAcceptanceRate?.data?.data;
      const cancellationData = cancellationRate?.data?.data;

      if (summaryData && delayData) {
        const colors = [
          "#D6ECFF", // Light Blue
          "#E4F9E3", // Light Green
          "#FFEBCB", // Light Orange
          "#DEE5FF", // Soft Indigo
          "#FFD6D6", // Light Rose
          "#D4F1FF", // Ice Blue
          "#E3EEFF", // Pale Sky
          "#F0DEFF", // Light Lavender
          "#E9F8E5", // Minty Green
          "#FFDFF0", // Baby Pink
        ];

        const newStats = [
          {
            title: "Total Applications",
            value: summaryData?.TotalJobApplications,
            Icon: <PeopleIcon />,
          },
          {
            title: "Total Cancelled",
            value: summaryData?.CancelledCandidates,
            Icon: <CancelIcon />,
          },
          {
            title: "Total Deployed",
            value: summaryData?.HiredCandidates,
            Icon: <FlightTakeoffIcon />,
          },
          {
            title: "Average Time to Deploy",
            value: delayData?.avgDelayInDays
              ? `${parseInt(Number(delayData?.avgDelayInDays))} days`
              : delayData?.avgDelayInDays,
            Icon: <HourglassEmptyIcon />,
          },
          {
            title: "Candidates With Web Access",
            value: summaryData?.TotalWebportalAccess,
            Icon: <WebAssetIcon />,
          },
          {
            title: "Candidates Without Web Access",
            value: summaryData?.NoWebPortalAccess,
            Icon: <WebAssetOffIcon />,
          },

          {
            title: "Selection Rate",
            value: selectionData?.SelectionPercentage
              ? `${parseInt(Number(selectionData?.SelectionPercentage))}%`
              : selectionData?.SelectionPercentage,
            Icon: <TrendingUpIcon />,
          },
          {
            title: "Document Submission Rate",
            value: docSubRateData?.DocumentSubmissionPercentage
              ? `${parseInt(
                  Number(docSubRateData?.DocumentSubmissionPercentage)
                )}%`
              : docSubRateData?.DocumentSubmissionPercentage,
            Icon: <UploadFileIcon />,
          },
          {
            title: "Offer Accept Rate",
            value: offerAcceptanceData?.OfferAcceptanceRate
              ? `${parseInt(Number(offerAcceptanceData?.OfferAcceptanceRate))}%`
              : offerAcceptanceData?.OfferAcceptanceRate,
            Icon: <ThumbUpIcon />,
          },
          {
            title: "Cancellation Rate",
            value: cancellationData?.CancellationRate
              ? `${parseInt(Number(cancellationData?.CancellationRate))}%`
              : cancellationData?.CancellationRate,
            Icon: <ThumbDownIcon />,
          },
        ].map((stat, index) => ({
          ...stat,
          color: colors[index % colors.length],
        }));

        setCandidateStatData(newStats); // set all 5 at once
      }
    } catch (err) {
      console.error("Error fetching candidate stats:", err);
    }
  };

  const getCountriesInProgress = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/country-inprogress`);
      setCountriesInProgress(res?.data?.data);
    } catch (err) {}
  };

  const getCountriesDeployed = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/country-deployed`);
      setDepoyedByCountry(res?.data?.data);
    } catch (err) {}
  };

  const getProfessionStats = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/profession-stats`);
      setProfessionStats(res?.data?.data);
    } catch (err) {}
  };

  const getJobs = async () => {
    try {
      const res = await axiosAPI?.get(`/Job/active/list`);
      const jobs = res?.data?.data || [];

      const jobListWithAll = [{ JD_Title: "All Jobs", JD_Id: null }, ...jobs];

      setJobList(jobListWithAll);
    } catch (err) {}
  };

  const getRecruitmentProcedurelist = async () => {
    try {
      const res = await axiosAPI.get(`/RecruitmentProcedure/list`);
      setProcessList(res?.data?.data || []);
      setProcessName(res?.data?.data[0]?.RP_Id);
    } catch (err) {
      console.error(err);
    }
  };

  const getInterviewStats = async () => {
    try {
      const res = await axiosAPI?.post(`/reports/interview-stats`, {
        job: selectedJob,
      });

      setInterviewStats(res?.data?.data);
    } catch (err) {}
  };

  const getCandidateProcess = async () => {
    try {
      const res = await axiosAPI?.post(`/reports/candidate-process`, {
        RP_Id: processName,
      });

      setCandidateProcessData(res?.data?.data);
    } catch (err) {}
  };

  // Jobs API       ___________________________________________________________________________________________________________________________________________________________________________________

  const getJobData = async () => {
    try {
      const [
        jobSummaryRes,
        jobFullfillmentRes,
        interviewRateRes,
        offeracceptRes,
        cancelOpenVacancyRes,
      ] = await Promise.all([
        axiosAPI.get(`/reports/job-summary`),
        axiosAPI.get(`/reports/job-fullfillment`),
        axiosAPI.get(`/reports/interview-rate`),
        axiosAPI.get(`/reports/offeraccept-by-rejected`),
        axiosAPI.get(`/reports/Cancelled-openvaccancies`),
      ]);
      const JobSummaryData = jobSummaryRes?.data?.data;
      const jobFullfillmentData = jobFullfillmentRes?.data?.data;
      const interviewRateData = interviewRateRes?.data?.data;
      const offeracceptData = offeracceptRes?.data?.data;
      const cancelOpenVacancyData = cancelOpenVacancyRes?.data?.data;

      const colors = [
        "#D6ECFF", // Light Blue
        "#E4F9E3", // Light Green
        "#FFEBCB", // Light Orange
        "#DEE5FF", // Soft Indigo
        "#FFD6D6", // Light Rose
        "#D4F1FF", // Ice Blue
        "#E3EEFF", // Pale Sky
        "#F0DEFF", // Light Lavender
        "#E9F8E5", // Minty Green
        "#FFDFF0", // Baby Pink
      ];

      const updatedJobStatData = [
        {
          title: "Total Jobs Posted",
          value: JobSummaryData?.TotalJobsPosted,
          Icon: <WorkOutlineIcon />,
        },
        {
          title: "Total Open Jobs",
          value: JobSummaryData?.TotalOpenJobs,
          Icon: <WorkIcon />,
        },
        {
          title: "Total Job Completed",
          value: JobSummaryData?.TotalClosedJobs,
          Icon: <WorkOffIcon />,
        },
        {
          title: "Total Job Openings",
          value: JobSummaryData?.TotalJobOpenings,
          Icon: <PostAddIcon />,
        },
        {
          title: "Total Applications",
          value: JobSummaryData?.TotalApplications,
          Icon: <GroupIcon />,
        },
        {
          title: "Total Hired Candidates",
          value: JobSummaryData?.TotalHiredCandidates,
          Icon: <FlightTakeoffIcon />,
        },
        {
          title: "Offer Letters Accepted",
          value: JobSummaryData?.TotalOfferLettersAccepted,
          Icon: <ThumbUpIcon />,
        },
        {
          title: "Offer Acceptance Rate",
          value:
            JobSummaryData?.OfferAcceptanceRate != null
              ? Number(JobSummaryData.OfferAcceptanceRate)
                  .toString()
                  .startsWith("0")
                ? `${Number(JobSummaryData.OfferAcceptanceRate).toFixed(2)}%`
                : `${parseInt(JobSummaryData.OfferAcceptanceRate)}%`
              : "",
          Icon: <TrendingUpIcon />,
        },
        {
          title: "Total Attended Interviews",
          value: interviewRateData?.TotalAttendedInterviews,
          Icon: <PendingActionsIcon />,
        },
        {
          title: "Job Fulfillment Rate",
          value:
            jobFullfillmentData?.DeploymentPercentage != null
              ? Number(jobFullfillmentData.DeploymentPercentage)
                  .toString()
                  .startsWith("0")
                ? `${Number(jobFullfillmentData.DeploymentPercentage).toFixed(
                    2
                  )}%`
                : `${parseInt(jobFullfillmentData.DeploymentPercentage)}%`
              : "",
          Icon: <AutoGraphIcon />,
        },
        {
          title: "Interview attendance Rate",
          value:
            interviewRateData?.InterviewAttendancePercentage != null
              ? Number(interviewRateData.InterviewAttendancePercentage)
                  .toString()
                  .startsWith("0")
                ? `${Number(
                    interviewRateData.InterviewAttendancePercentage
                  ).toFixed(2)}%`
                : `${parseInt(
                    interviewRateData.InterviewAttendancePercentage
                  )}%`
              : "",
          Icon: <EventAvailableIcon />,
        },
        {
          title: "Offer Acceptance Percentage",
          value:
            offeracceptData?.OfferAcceptancePercentage != null
              ? Number(offeracceptData.OfferAcceptancePercentage)
                  .toString()
                  .startsWith("0")
                ? `${Number(offeracceptData.OfferAcceptancePercentage).toFixed(
                    2
                  )}%`
                : `${parseInt(offeracceptData.OfferAcceptancePercentage)}%`
              : "",
          Icon: <DoneOutlineIcon />,
        },
        {
          title: "Total Cancelled Candidates",
          value: cancelOpenVacancyData?.TotalCancelledCandidates,
          Icon: <CancelIcon />,
        },
        {
          title: "Total Open Vacancies",
          value: cancelOpenVacancyData?.TotalOpenVacancies,
          Icon: <DomainAddIcon />,
        },
      ].map((stat, index) => ({
        ...stat,
        color: colors[index % colors.length],
      }));

      setJobStatData(updatedJobStatData);
    } catch (err) {
      console.error("Error fetching candidate stats:", err);
    }
  };

  const getJobApplications = async () => {
    await axiosAPI
      ?.post(`/reports/job-post/month`, { year: year3 })
      .then((res) => {
        const monthShortNames = {
          January: "Jan",
          February: "Feb",
          March: "Mar",
          April: "Apr",
          May: "May",
          June: "Jun",
          July: "Jul",
          August: "Aug",
          September: "Sept",
          October: "Oct",
          November: "Nov",
          December: "Dec",
        };

        const updatedData = res?.data?.data?.map((item) => ({
          ...item,
          MonthName: monthShortNames[item.MonthName] || item.MonthName,
        }));

        setJobApplicationData(updatedData);
      })
      .catch((err) => {});
  };

  const getJobPostStats = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/job-post-stats`);
      setJobPostStats(res?.data?.data);
    } catch (err) {}
  };

  const getJobProfStats = async () => {
    await axiosAPI
      ?.get(`/reports/Profession/job-stats`)
      .then((res) => {
        setJobProfStats(res?.data?.data);
      })
      .catch((err) => {});
  };

  const getJobClientStats = async () => {
    await axiosAPI
      ?.get(`/reports/client/job-stats`)
      .then((res) => {
        setJobClientStats(res?.data?.data);
      })
      .catch((err) => {});
  };

  const getDeployedJobStats = async () => {
    await axiosAPI
      ?.get(`/reports/deployed-job-stats`)
      .then((res) => {
        setDeployedJobStats(res?.data?.data);
      })
      .catch((err) => {});
  };

  // Staff API      ___________________________________________________________________________________________________________________________________________________________________________________
  const getStaffProcessStats = async () => {
    await axiosAPI
      ?.post(`/reports/Staff-Process-Stats`, {
        RP_Id: processName ? processName : null,
        StaffId: staffName ? staffName : null,
        Startdate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
        Stage_id: recruitmentStage ? recruitmentStage : null,
      })
      .then((res) => {
        setStaffProcessStats(res?.data?.data);
      })
      .catch((err) => {});
  };

  const getRecruitmentStageslist = async () => {
    try {
      const res = await axiosAPI.post(
        `/RecruitmentProcedure/recruitmentstages`,
        {
          procedureID: processName,
        }
      );
      setRecruitmentStageslist(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffInterviewScheduled = async () => {
    try {
      const res = await axiosAPI.post(`/reports/Staff-Interviewattend-Stats`, {
        StaffId: staffName2,
        StatusId: interviewStatus,
      });
      setStaffInterviewScheduledList(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffCancelRate = async () => {
    try {
      const res = await axiosAPI.post(`/reports/Cancel-rate-staff`, {
        StaffId: staffName3,
      });
      setStaffCancelRate(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffOfferStats = async () => {
    try {
      const res = await axiosAPI.post(`/reports/offer-stats-staff`, {
        StaffId: staffName4,
      });
      setStaffOfferStats(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getCandidateByStaff = async () => {
    try {
      const res = await axiosAPI.post(`/reports/Candidate-by-staff`, {
        StaffId: staffName5,
      });

      setCandidateByStaff(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getStatus = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/list`);
      setStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const options = Array.from(
      { length: new Date().getFullYear() + 10 - 2020 + 1 },
      (_, i) => {
        const year = 2020 + i;
        return { label: String(year), value: String(year) };
      }
    );

    setYearOptions(options);

    getJobs();
    getRecruitmentProcedurelist();

    // Client
    getClientData();
    getTopClients();

    // Candidate
    getCandidateStats();
    getCountriesInProgress();
    getCountriesDeployed();
    getProfessionStats();

    // Job
    getJobData();
    getJobPostStats();
    getJobProfStats();
    getJobClientStats();
    getDeployedJobStats();

    // Staff
    getStaff();
    getStatus();
  }, []);

  useEffect(() => {
    getInterviewStats();
  }, [selectedJob]);

  useEffect(() => {
    getClientJobPosted();
  }, [year]);

  useEffect(() => {
    getJobApplications();
  }, [year3]);

  useEffect(() => {
    getRecruitmentStageslist();
  }, [processName]);

  useEffect(() => {
    getCandidateProcess();
  }, [processName]);

  useEffect(() => {
    getStaffProcessStats();
  }, [staffName, processName, startDate, endDate, recruitmentStage]);

  useEffect(() => {
    getStaffInterviewScheduled();
  }, [staffName2, interviewStatus]);

  useEffect(() => {
    getStaffCancelRate();
  }, [staffName3]);

  useEffect(() => {
    getStaffOfferStats();
  }, [staffName4]);

  useEffect(() => {
    getCandidateByStaff();
  }, [staffName5]);

  const renderReportContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <ClientReportView
            clientStatData={clientStatData}
            mostCandidateDeployed={mostCandidateDeployed}
            topClients={topClients}
            NewClientData={NewClientData}
            yearOptions={yearOptions}
            year={year}
            setYear={setYear}
          />
        );
      case 1:
        return (
          <CandidateReportView
            candidateStatData={candidateStatData}
            candidateProcessData={candidateProcessData}
            countriesInProgress={countriesInProgress}
            depoyedByCountry={depoyedByCountry}
            professionStats={professionStats}
            interviewStats={interviewStats}
            JobList={JobList}
            selectedJob={selectedJob}
            setSelectedJob={setSelectedJob}
            processList={processList}
            processName={processName}
            setProcessName={setProcessName}
          />
        );
      case 2:
        return (
          <JobReportView
            jobStatData={jobStatData}
            jobApplicationData={jobApplicationData}
            deployedJobStats={deployedJobStats}
            yearOptions={yearOptions}
            year={year3}
            setYear={setYear3}
            jobPostStats={jobPostStats}
            jobProfStats={jobProfStats}
            jobClientStats={jobClientStats}
          />
        );

      case 3:
        return (
          <StaffReportView
            data={staffProcessStats}
            yearOptions={yearOptions}
            year={year}
            setYear={setYear}
            processList={processList}
            processName={processName}
            setProcessName={setProcessName}
            staffList={staffList}
            staffName={staffName}
            staffName2={staffName2}
            staffName3={staffName3}
            staffName4={staffName4}
            staffName5={staffName5}
            setStaffName={setStaffName}
            setStaffName2={setStaffName2}
            setStaffName3={setStaffName3}
            setStaffName4={setStaffName4}
            setStaffName5={setStaffName5}
            staffCancelRate={staffCancelRate}
            staffOfferStats={staffOfferStats}
            candidateByStaff={candidateByStaff}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            RecruitmentStageslist={RecruitmentStageslist}
            recruitmentStage={recruitmentStage}
            setRecruitmentStage={setRecruitmentStage}
            staffInterviewScheduledList={staffInterviewScheduledList}
            statusList={statusList}
            interviewStatus={interviewStatus}
            setInterviewStatus={setInterviewStatus}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="error"
        textColor="error"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabLabels.map((label, index) => (
          <Tab
            sx={{
              fontFamily: "Geist, sans-serif",
              background: selectedTab == index ? "#006CB8" : "#EBF2FF",
              border: "1px solid lightgrey",
              borderBottom: "4px solid #EAB308",
              color: selectedTab == index ? "white" : "black",
              fontWeight: 500,
              fontSize: `14px`,
              letterSpacing: "1px",
              minWidth: "150px",
              minHeight: "60px",
            }}
            key={index}
            label={label}
          />
        ))}
      </Tabs>
      <Box sx={{ border: "1px solid lightgrey" }}>{renderReportContent()}</Box>
    </Paper>
  );
};

export default Reports;
